import securityPatchModal from './security-patch-modal.connect'

export default securityPatchModal
